import {createDispatchHook, createSelectorHook} from 'react-redux';

import {EDTContext} from './context';

import type {AppDispatch, RootState} from './store';
import type {TypedUseSelectorHook} from 'react-redux';

export const useAppDispatch: () => AppDispatch = createDispatchHook(EDTContext);
export const useAppSelector: TypedUseSelectorHook<RootState> = createSelectorHook(EDTContext);
